import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { PaisMercadoGlobalEnum } from '../../../../common/types/enums/pais-mercado-global.enum';

const InputWrap = styled.div`
  position: relative;

  label {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--muted);
    font-size: 14px;
    transition: all 0.15s ease;
    pointer-events: none;
    background: var(--card);
    padding: 0 6px;
  }

  input {
    width: 100%;
    height: 44px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    padding: 0 12px;
    background: #fff;
    font-size: 14px;
  }

  input:focus {
    outline: 0;
    border-color: var(--blue);
    box-shadow: 0 0 0 3px rgba(40, 121, 254, 0.12);
  }

  /* efeito "float label" */
  input:not(:placeholder-shown) + label,
  input:focus + label {
    top: 0;
    transform: translateY(-50%) scale(0.9);
    color: var(--muted);
  }
`;

type Props = {
  country: PaisMercadoGlobalEnum;
  value: string;
  onChange: (value: string) => void;
  id?: string;
  label?: string;
};

export const ZipCodeInputModern: React.FC<Props> = ({
  value,
  onChange,
  country,
  id,
  label = 'ZIP / Postal code*',
}) => {
  const [mask, setMask] = useState(
    country === PaisMercadoGlobalEnum.EUA ? '99999' : '99999-999',
  );

  // Atualiza a máscara caso o país mude
  useEffect(() => {
    if (country === PaisMercadoGlobalEnum.EUA) {
      setMask('99999');
    } else {
      setMask('99999-999');
    }
  }, [country]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const numeric = raw.replace(/\D/g, '');

    if (country === PaisMercadoGlobalEnum.EUA) {
      if (numeric.length > 5 && mask !== '99999-9999') {
        setMask('99999-9999');
      }
      if (numeric.length <= 5 && mask !== '99999') {
        setMask('99999');
      }
    } else {
      if (mask !== '99999-999') {
        setMask('99999-999');
      }
    }

    onChange(raw);
  };

  return (
    <InputWrap>
      <InputMask
        id={id}
        mask={mask}
        value={value}
        onChange={handleChange}
        maskChar=""
        // placeholder precisa ser " " pra ativar o :placeholder-shown do float label
        placeholder=" "
      >
        {(inputProps: any) => <input {...inputProps} />}
      </InputMask>
      <label>{label}</label>
    </InputWrap>
  );
};
